import { User } from 'firebase/auth';

export type FirebaseUser = User | null;

export type IOrderSource = '' | 'Kiosk' | 'App' | 'Web';

export enum IOrderStatus {
    Ready = 'Ready',
    InProgress = 'In Progress',
    NotStarted = 'Not Started',
}

export type IOrder = {
    id: string;
    customerFirstName: string;
    orderNo: string;
    orderSource: IOrderSource;
    orderState: IOrderStatus;
};

export enum TransactionSource {
    App = 'app',
    Kiosk = 'kiosk',
    Online = 'online',
}

export enum Screen {
    EnterPhone,
    Verify,
}

export type AppDocument = Document & {
    API_ENDPOINT?: string;
    DEVICE_ID?: string;
    SERIAL_NO?: string;
    DEVICE_HASH?: string;
    DEVICE_TOKEN?: string;
};
